export default __webpack_public_path__ + "static/media/Harbinger of Dying Breaths.b93dd7d8.jpg";